import React, { useState } from 'react';
import classNames from 'classnames';
import Icon from 'react-multi-date-picker/components/icon';
import { NavLink } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../components/base/Dialog/Dialog';
import TabMenu from '../../../components/base/TabMenu/TabMenu';
import VerticalGrid from '../../../components/base/Grid/VerticalGrid';
import GovermentNumber from '../../System/components/GovermentNumber/GovermentNumber';
import BlockHeader from '../../../components/layout/BlockHeader';
import CheckBoxInputWithLabel from '../../../components/fields/CheckBoxInput/CheckBoxInputWithLabel';

export default function SessionViewModal(props) {
  const { handleClose = () => {}, session } = props;
  const [selectedPhoto, selectPhoto] = useState(0);
  const [showIntermediateFrames, setShowIntermediateFrames] = useState(0);
  const [selectedPFPhotoType, selectPFPhotoType] = useState(0);
  const [startIndex, setStartIndex] = useState(0);
  const intl = useIntl();
  const { formatMessage } = intl;
  const photoList = [{ photo: 'photo-1.jpeg' }, { photo: 'photo-2.jpeg' }, { photo: 'photo-3.jpeg' }, { photo: 'photo-4.jpeg' }, { photo: 'photo-1.jpeg' }];
  const maxCount = 4;
  const viewedList = photoList.slice(startIndex, maxCount + startIndex);
  const pfPhotoType = [
    { value: 0, label: formatMessage({ id: 'pf.photo.type.0' }) },
    { value: 1, label: formatMessage({ id: 'pf.photo.type.1' }) },
    { value: 2, label: formatMessage({ id: 'pf.photo.type.2' }) },
  ];
  const pfRows = {
    start: formatMessage({ id: 'session.start' }),
    end: formatMessage({ id: 'session.end' }),
    date: formatMessage({ id: 'session.date' }),
    zone: formatMessage({ id: 'session.zone' }),
    preset: formatMessage({ id: 'session.preset' }),
    chanel: formatMessage({ id: 'session.chanel' }),
    reg_number: formatMessage({ id: 'session.reg_number' }),
    reg_number_type: formatMessage({ id: 'session.reg_number_type' }),
    gps: formatMessage({ id: 'session.gps' }),
    address: formatMessage({ id: 'session.address' }),
  };
  const violationRow = {
    type: formatMessage({ id: 'violation.type' }),
    start: formatMessage({ id: 'violation.start' }),
    end: formatMessage({ id: 'violation.end' }),
    code: formatMessage({ id: 'violation.code' }),
  };

  const pfData = {
    start: '2024-07-06T11:10:05.000Z',
    end: '2024-07-06T11:22:54.000Z',
    date: '2024-07-06T11:22:54.000Z',
    zone: 'A',
    preset: 'A',
    chanel: 1,
    reg_number: 'С582МР152',
    reg_number_type: 'RU 1',
    gps: '56.021196, 37.479523',
    address: 'г. Москва, ул. Тверская, д. 59, корп. 1',
  };

  const govermentNumber = {
    type: '',
    number: '845',
    char: 'M',
    charSecond: 'OX',
    region: 199,
    country: 'RUS',
  };
  const violationList = [
    {
      type: 'Заезд на газон',
      start: '2024-07-06T11:10:05.000Z',
      end: '2024-07-06T11:22:54.000Z',
      code: 344,
    },
    {
      type: 'Выезд за стоп-линию на запрещающий сигнал светофора',
      start: '2024-07-06T11:10:05.000Z',
      end: '2024-07-06T11:22:54.000Z',
      code: 101,
    },
  ];

  // const violationList = [];
  const prevButton = startIndex === 0;
  const nextButton = photoList.length > maxCount && startIndex + maxCount < photoList.length;

  return (
    <Dialog
      className="session-view-modal"
      size="xl"
      open
      onClose={handleClose}
    >
      <DialogTitle header={formatMessage({ id: 'session.violation.card' })} title={<Icons onClick={handleClose} customIcon icon="close" className="close" />} />
      <DialogContent>
        <div className="session-view-wrapper custom-scroll-theme">
          <div className="pf-list-column">
            <div className="pf-list-wrapper">
              <div className={classNames('pf-arrow pf-up white-button-style', { disabled: prevButton })} onClick={() => (prevButton ? null : setStartIndex(startIndex - 1))}><Icons customIcon icon="arrow-down" /></div>
              {viewedList.map((item, key) => (
                <div
                  key={key}
                  className={classNames('pf-list-item', { selected: selectedPhoto === key })}
                  onClick={() => selectPhoto(key)}
                  style={{ background: `url(${process.env.PUBLIC_URL}/mock/${item.photo}) no-repeat` }}
                />
              ))}
              <div className={classNames('pf-arrow pf-down white-button-style', { disabled: !nextButton })} onClick={() => (!nextButton ? null : setStartIndex(startIndex + 1))}><Icons customIcon icon="arrow-down" /></div>
            </div>
          </div>
          <div className="pf-info-column">
            <div className="pf-info-photo violation-photo" style={{ background: `url(${process.env.PUBLIC_URL}/mock/${viewedList[selectedPhoto].photo}) no-repeat` }}>
              <TabMenu options={pfPhotoType} selectedTab={selectedPFPhotoType} onSelectOptions={item => selectPFPhotoType(item.value)} />
            </div>
            <div className="pf-info-text">
              <div className="pf-info-left">
                <BlockHeader text={formatMessage({ id: 'session.drive.information' })} />
                <VerticalGrid data={pfData} rows={pfRows} />
              </div>
              <div className="pf-info-right">
                <div className="reg-number-image" style={{ background: `url(${process.env.PUBLIC_URL}/mock/plate.jpeg) no-repeat` }} />
                <GovermentNumber govermentNumber={govermentNumber} />
                <div className="quality-assurance"><div>{formatMessage({ id: 'reliability' })}</div><div className="quality">99%</div></div>
              </div>
            </div>
          </div>
          <div className="violation-info-column">
            <CheckBoxInputWithLabel label={formatMessage({ id: 'session.show.intermediate.frames' })} inputProps={{ value: showIntermediateFrames, onChange: () => { setShowIntermediateFrames(!showIntermediateFrames); } }} />
            <div className="violation-list-block">
              {violationList.map((item, index) => (
                <div key={index} className="violation-item">
                  <BlockHeader
                    text={`${formatMessage({ id: 'violation' })} ${index + 1}`}
                    content={(
                      <NavLink target="_blank" to="/session/violation" className="link-text">
                        {formatMessage({ id: 'show' })}
                        <Icons
                          width={24}
                          height={24}
                          customIcon
                          icon="arrow-right"
                          className="button-icons"
                        />
                      </NavLink>
                    )}
                  />
                  <VerticalGrid data={item} rows={violationRow} />
                </div>
              ))}
              {!violationList.length
                ? (
                  <div className="violation-item">
                    <BlockHeader text={formatMessage({ id: 'violation' })} />
                    <div className="no-violation">
                      <Icons customIcon icon="no-data" />
                      <div className="no-violation-text">{formatMessage({ id: 'no.data.available' })}</div>
                    </div>
                  </div>
                )
                : null}
            </div>
          </div>
        </div>
      </DialogContent>
      <DialogFooter>
        <Button onClick={() => handleClose()}>{formatMessage({ id: 'download' })}</Button>
        <Button variant="secondary" onClick={() => handleClose()}>{formatMessage({ id: 'close' })}</Button>
      </DialogFooter>
    </Dialog>
  );
}
